import { render, staticRenderFns } from "./ToolsPage.vue?vue&type=template&id=48b54a26&scoped=true&lang=pug&"
import script from "./ToolsPage.vue?vue&type=script&lang=js&"
export * from "./ToolsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b54a26",
  null
  
)

export default component.exports